






































































































































import {
    Component,
    ModelSync,
    Prop,
    PropSync,
    Vue,
    Watch,
} from 'vue-property-decorator';
import EventFlowStep from '@/model/enums/event-flow/event-flow-step';
import FormSelector from '@/components/form/FormSelector.vue';
import EventFlowFilter from '@/components/event-flow/EventFlowFilter.vue';
import EventFlowSwitch from '@/components/event-flow/EventFlowSwitch.vue';
import DateTimePicker from '@/components/form/DateTimePicker.vue';
import FormCheckbox from '@/components/form/FormCheckbox.vue';
import CustomModal from '@/components/modal/CustomModal.vue';
import SheetModal from '@/active-components/sheet/SheetModal.vue';
import { FormItem } from '@/model/form/FormItem';
import { Validations } from 'vuelidate-property-decorators';
import {
    EventFlowFilterData,
    EventFlowFormData,
    ExtraFunctionFormData,
} from '@/model/event-flow/EventFlow';
import { Sheet } from '@/model/Sheet';
import addToDate from 'date-fns/add';
import startOfDay from 'date-fns/startOfDay/index';
import { getEnumKeyByEnumValue } from '@/lib/helper/event-flow-helper';
import { Responsible } from '@/model/Responsible';
import { Topic } from '@/model/Topic';
import { PropType } from 'vue';

@Component({
    components: {
        EventFlowFilter,
        EventFlowSwitch,
        FormSelector,
        DateTimePicker,
        FormCheckbox,
        CustomModal,
        SheetModal,
    },
})
export default class EventFlowForm extends Vue {
    @ModelSync('form', 'change', { type: Object }) formData!: EventFlowFormData;
    @PropSync('filterData', { type: Object })
    readonly filterFormData!: EventFlowFilterData;

    @PropSync('extraData', {
        type: Object as PropType<ExtraFunctionFormData>,
        default: () => ({
            showTime: false,
            showBrief: false,
            showLegend: false,
        }),
    })
    readonly extraFunctionFormData!: ExtraFunctionFormData;

    @PropSync('eventFlowSelected', { type: Boolean })
    readonly eventFlowSelectedValue!: boolean;
    @Prop(Array) readonly responsibles!: Responsible[];
    @Prop(Array) readonly locations!: Location[];
    @Prop(Array) readonly topics!: Topic[];
    @Prop(Number) readonly eventId!: number;

    dateForm = {
        startTime: this.formData?.startDateTime ?? null,
        endTime: this.formData?.endDateTime ?? null,
    };

    get eventFlowStepValues(): FormItem[] {
        return Object.entries(EventFlowStep)
            .filter((entry) => {
                return typeof entry[1] === 'number';
            })
            .map((entry) => {
                return {
                    id: entry[0],
                    name: this.$t(`event-flow-step.${entry[0]}`).toString(),
                    value: entry[1],
                };
            });
    }

    @Validations()
    validations = {
        dateForm: {
            startTime: {
                maxValue(val: Date, { endTime }: { endTime: Date }): boolean {
                    if (val) {
                        return (
                            endTime.getTime() === startOfDay(val).getTime() ||
                            val < endTime
                        );
                    }

                    return val < endTime;
                },
            },
            endTime: {
                minValue(
                    val: Date,
                    { startTime }: { startTime: Date },
                ): boolean {
                    if (val) {
                        return (
                            val.getTime() === startOfDay(val).getTime() ||
                            val > startTime
                        );
                    }
                    return val > startTime;
                },
            },
        },
    };

    @Watch('dateForm', { deep: true })
    onDateFormChanged(): void {
        if (!this.$v.$invalid) {
            this.$emit('change', {
                ...this.formData,
                startDateTime: this.dateForm.startTime,
                endDateTime: this.dateForm.endTime,
            });
        }
    }

    @Watch('formData.startDateTime')
    @Watch('formData.endDateTime')
    onFormDataChanged(): void {
        this.dateForm.startTime = this.formData.startDateTime ?? null;
        this.dateForm.endTime = this.formData.endDateTime ?? null;
    }

    get getSheet(): Sheet {
        return {
            startedAt: this.formData.startDateTime,
            endedAt: this.formData.endDateTime,
            step: getEnumKeyByEnumValue(EventFlowStep, this.formData.step),
            time: this.extraFunctionFormData.showTime,
            brief: this.extraFunctionFormData.showBrief,
            legend: this.extraFunctionFormData.showLegend,
            locationFilters: this.filterFormData.locationFilters ?? [],
            topicFilters: this.filterFormData.topicFilters ?? [],
            responsibleFilters: this.filterFormData.responsibleFilters ?? [],
        } as Sheet;
    }

    stepDay(add: boolean): void {
        this.formData.date = addToDate(this.formData.date ?? new Date(), {
            days: add ? 1 : -1,
        });
    }
}
